import template from './site-filters.component.html';

class SiteFiltersController {
  constructor() {
    'ngInject';
  }

  clickClearFilters() {
    this.clearFilters();
  }

  clickCloseFilters() {
    this.closeFilters();
  }

  onFiltersChanged() {
    this.filterChanged();
  }
}

export default {
  template,
  controller: SiteFiltersController,
  controllerAs: 'vm',
  bindings: {
    clearFilters: '&',
    filterChanged: '&',
    closeFilters: '&',
    filters: '=',
  },
};
